const navLinkStyledSignUp = {
  text: 'Already have an account? Sign in'
};

export default navLinkStyledSignUp;
